import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import AttachmentType from 'app/shared-components/Attachment/Attachment.types'
import requests from 'app/requests/Attachment.requests'

const useGetAttachment = (id) => {
    return useRequest<AttachmentType>({
        key: RequestKeys.getAttachment,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(requests.get),
        enabled: Boolean(id),
    })
}

export default useGetAttachment
